import { Component, HostBinding, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgSwitch, NgSwitchCase } from '@angular/common';
import { GrowlerType } from './growler.service';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressBarModule } from '@angular/material/progress-bar';

export interface GrowlerAction
{
    label: string;
    route: string;
}

export interface GrowlerInput
{
    title: string;
    message: string;
    type: GrowlerType;
    autoDismissAfter: number;
    action?: GrowlerAction;
}

@Component({
    selector: 'app-growler',
    templateUrl: './growler.component.html',
    styleUrls: ['./growler.component.scss'],
    standalone: true,
    imports: [
        MatIconModule,
        NgIf,
        NgSwitch,
        NgSwitchCase,
        MatButtonModule,
        MatProgressBarModule,
    ],
})
export class GrowlerComponent implements OnInit
{
    @HostBinding('class.growler-content') readonly growlerContent = true;

    progressBarInterval: NodeJS.Timer = null;
    percentRemaining = 100;

    readonly types = GrowlerType;

    constructor(
        private _snackRef: MatSnackBarRef<GrowlerComponent>,
        @Inject(MAT_SNACK_BAR_DATA) public data: GrowlerInput,
        private _router: Router,
    ) {
    }

    get sticky(): boolean {
        return !(this.data.autoDismissAfter > 0);
    }

    ngOnInit() {
        if (this.sticky) {
            return;
        }
        this.progressBarInterval = setInterval(() => {
            this.percentRemaining = this.percentRemaining - Math.floor(( 100 / (this.data.autoDismissAfter / 100)));
            if (this.percentRemaining < 0) {
                clearInterval(this.progressBarInterval);
            }
        }, 100);
    }

    dismiss() {
        if (this.progressBarInterval) {
            clearInterval(this.progressBarInterval);
            this.progressBarInterval = null;
        }
        this._snackRef.dismiss();
    }

    runAction(event: MouseEvent) {
        const route = this.data.action?.route;
        const newTab = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
        this.dismiss();
        if (newTab) {
            return;
        }
        event.preventDefault();
        if (route) {
            this._router.navigateByUrl(route).finally(() => this._snackRef.dismiss());
        }
    }
}
